import { z } from "zod";

const PASSWORD_CONSTRAINTS = {
  length: {
    minimum: 8,
    maximum: 32,
  },
};

const zPasswordSchema = z
  .string()
  .trim()
  .min(PASSWORD_CONSTRAINTS.length.minimum)
  .max(PASSWORD_CONSTRAINTS.length.maximum);

export { PASSWORD_CONSTRAINTS, zPasswordSchema };
